var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrderWithoutInvoice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0623 4H7.71655V6H12.0623V8H5.71655V6H3.71655V20H17.7166V11.9375H19.7166V21.0068C19.7164 21.5553 19.2708 22 18.7224 22H2.70972C2.16116 22 1.7157 21.5552 1.71558 21.0068V4.99316C1.7157 4.44463 2.16135 4 2.70972 4H5.71655V2H12.0623V4Z",
    fill: "#525256"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8837 11.3373H14.3476C13.5741 11.3373 12.947 10.7102 12.947 9.93669V2.46686C12.947 2.20902 13.156 2 13.4139 2H19.95C20.2078 2 20.4168 2.20902 20.4168 2.46686V8.06923H22.2843V9.93669C22.2843 10.7102 21.6573 11.3373 20.8837 11.3373ZM20.4168 9.00296V9.93669C20.4168 10.1945 20.6259 10.4036 20.8837 10.4036C21.1416 10.4036 21.3506 10.1945 21.3506 9.93669V9.00296H20.4168ZM19.4831 10.4036V2.93373H13.8807V9.93669C13.8807 10.1945 14.0898 10.4036 14.3476 10.4036H19.4831ZM14.8145 4.33432H18.5494V5.26805H14.8145V4.33432ZM14.8145 6.20178H18.5494V7.1355H14.8145V6.20178ZM14.8145 8.06923H17.1488V9.00296H14.8145V8.06923Z",
    fill: "#787E82"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderWithoutInvoice);
export default __webpack_public_path__ + "static/media/order-without-invoice.8a9ee30ced4881f303522fc9da2a7393.svg";
export { ForwardRef as ReactComponent };